export default __webpack_public_path__ + "static/media/property_399.61b9a11b.png";